import React, { useEffect, useState } from 'react';
import { LoadingOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import Modal from 'antd/lib/modal/Modal';
import { Form, Button, Input, Skeleton, message } from 'antd';
import { transformPro } from '../../shared/hooks/transfromApiData';
import { useQueryHook } from '../../shared/hooks/useQueryHook';
import { AddShippingMode, GetAllShippingModes, DeleteShippingMode, UpdateShippingMode } from '../../shared/common/graphqlQuery';
import { useMutationHook } from '../../shared/hooks/useMutationHook';
import { companyData } from '../../core/auth';
import CommonEditableTable from '../../shared/components/commonEditableTable/commonEditableTable';

let deleteId;
const onError = (error: any, result: any) => {
    console.log(error, result);
}
const columns = [
    {
        title: 'Shipping Mode',
        dataIndex: 'shippingMode',
        key: 'shippingMode',
        editable: true,
        sorter: true,
    }
];
const ShippingMode = () => {
    const companyId = companyData().getCompanyData();
    const [ShippingModesform] = Form.useForm();
    const [visibleShippingMode, setVisibleShippingMode] = useState<boolean>(false);
    const ShippingModesQuery = useQueryHook(GetAllShippingModes, { companyId: companyId });
    const [ShippingModeData, setShippingModeData] = useState([]);

    useEffect(() => {
        setShippingModeData(transformPro(ShippingModesQuery.data?.getAllShippingModes))
    }, [ShippingModesQuery.data?.getAllShippingModes]);

    const onSubmittedShippingMode = (result: any) => {
        const newAddedData = transformPro(result.addShippingMode);
        const tableData = [...ShippingModeData];
        tableData.push(...newAddedData);
        setShippingModeData([...tableData]);
        handleCancelShippingMode();
    }

    const onDeleteShippingMode = (result: any) => {
        const constData = [...ShippingModeData];
        const deletedIndex = constData.findIndex(eachData => eachData.key === deleteId);
        constData.splice(deletedIndex, 1);
        setShippingModeData([...constData]);
        message.success(result.deleteShippingMode.message);
    }

    const onUpdatedShippingMode = (result) => {
        const newData = [...ShippingModeData];
        const index = newData.findIndex(item => result.updateShippingMode['_id'] === item.key);
        if (index > -1) {
            newData[index].shippingMode = result.updateShippingMode.shippingMode
            setShippingModeData([...newData])
        }
    }

    const ShippingModeMutation = useMutationHook(AddShippingMode, onSubmittedShippingMode, onError);
    const DeleteShippingModeMutation = useMutationHook(DeleteShippingMode, onDeleteShippingMode, onError);
    const UpdateShippingModeMutation = useMutationHook(UpdateShippingMode, onUpdatedShippingMode, onError);


    const showModalShippingMode = () => {
        setVisibleShippingMode(true);
    };
    const handleCancelShippingMode = () => {
        setVisibleShippingMode(false);
        ShippingModesform.resetFields();
    };
    const onFinishShippingMode = (values: any) => {
        if(!ShippingModeMutation.loading ) {
            ShippingModeMutation.callMutation({ variables: { shippingModeInput: { ...values, companyId } } })
        }
    };

    const onSave = (value) => {
        if(!UpdateShippingModeMutation.loading) {
            UpdateShippingModeMutation.callMutation({ variables: { updateShippingModeInput: { companyId, shippingModeId: value.key, shippingMode: value.shippingMode } } })
        }
    }
    const onDelete = (value) => {
        if(!DeleteShippingModeMutation.loading) {
            deleteId = value.key;
            DeleteShippingModeMutation.callMutation({ variables: { deleteShippingModeInput: { companyId, shippingModeId: value.key } } })
        }
    }
    return (
        <>
            <Button type="primary" onClick={showModalShippingMode} style={{ marginBottom: 10, marginTop: 10 }}>
                Add Shipping Mode
            </Button>
            <Modal
                title="Add Shipping Mode"
                style={{ top: 20 }}
                visible={visibleShippingMode}
                onCancel={handleCancelShippingMode}
                footer={[
                    <Button key="back" style={{ width: 75 }}  onClick={handleCancelShippingMode}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" ghost style={{ width: 75 }} onClick={() => {
                        ShippingModesform
                            .validateFields()
                            .then(values => {
                                onFinishShippingMode(values);
                            })
                            .catch(info => {
                            });
                    }}>
                        {ShippingModeMutation.loading ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Submit'}
                    </Button>,
                ]}>
                <Form
                    form={ShippingModesform}
                    style={{ textAlign: "center" }}
                    name="dynamic_form_item"
                    initialValues={{
                        shippingModes: []
                    }}>
                    <Form.List name="shippingModes" >
                        {(fields, { add, remove }) => {
                            return (
                                <div>
                                    {fields.map((field, index) => (
                                        <Form.Item
                                            required={false}
                                            key={field.key}
                                        >
                                            <Form.Item
                                                {...field}
                                                validateTrigger={['onChange', 'onBlur']}
                                                rules={[
                                                    {
                                                        required: true, whitespace: true,
                                                        message: "Please input Shipping Mode or delete this field.",
                                                    },
                                                ]}
                                                noStyle
                                            >
                                                <Input autoComplete="off" placeholder="Shipping Mode" style={{ width: '60%' }} />
                                            </Form.Item>
                                            {fields.length > 1 ? (
                                                <MinusCircleOutlined
                                                    className="dynamic-delete-button"
                                                    style={{ margin: '0 8px' }}
                                                    onClick={() => {
                                                        remove(field.name);
                                                    }}
                                                />
                                            ) : null}
                                        </Form.Item>
                                    ))}
                                    <Form.Item>
                                        <Button type="dashed"
                                            onClick={() => {
                                                add();
                                            }}
                                            style={{ marginLeft: -30, width: '60%' }} >
                                            <PlusOutlined /> Add field
                                        </Button>
                                    </Form.Item>
                                </div>
                            );
                        }}
                    </Form.List>
                </Form>
            </Modal>

            {ShippingModesQuery.loading ? <Skeleton active /> :
                <CommonEditableTable
                    columns={columns}
                    tableRowdata={ShippingModeData}
                    onDelete={onDelete}
                    onSave={onSave}
                    customFormData={{ shippingMode: '' }} />
            }</>

    );
}
export default ShippingMode